module.exports = __webpack_public_path__ + "static/img/bombarque.ba6a983.png";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/bombarque.png
// module id = vFJu
// module chunks = 1